import ItemsCollection, {Item} from './ItemsCollection';

import Axios from 'axios';
import Module from './Module';
import axiosInstance from '@/helpers/axios';
import stores from '@/stores/index';
import {generateLog} from '@/helpers/functions';
import {showToaster} from "@/components/DashboardComposer/helpers";

const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class VODModuleItem extends Item implements IVIDEO {
  id!: number | null;
  name!: string;
  shortDescription!: string;
  sources!: IVideoSource[];
  trailers!: IVideoSource[];
  description!: string;
  details!: any;
  cast!: ICast[];
  type!: string;
  imageId!: number | null;
  year!: number | null;
  adult!: boolean;
  active!: boolean;
  sort!: null;
  seriesId!: number | null;
  episode!: number | null;
  season!: number | null;
  categories!: ICategories[];
  parentId!: number | null;
  gallery!: IMediaItem[];
}

export class VODItemsCollection extends ItemsCollection<VODModuleItem> {
  model() {
    return VODModuleItem;
  }

  url(): string {
    return this.module.url();
  }

  getMovies() {
    return axiosInstance.get(this.url())
      .then((response) => response.data);
  }

}

export default class VODModule extends Module<VODItemsCollection> {

  routeName = 'video';

  Collection() {
    return VODItemsCollection;
  }

  url() {
    return `/video/${this.id}`;
  }

  urlMovie() {
    return `${this.url()}/movies`;
  }

  urlCategory() {
    return `${this.url()}/categories`;
  }

  updateItem(id: any, data: any) {
    return axiosInstance.patch(`${this.urlMovie()}/${id}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  updateCategory(id: any, data: any) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  detachGallery(id: number, imageId: number) {
    return axiosInstance.post(`${this.urlMovie()}/${id}/detach/gallery`, {id: imageId})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  attachGallery(id: number, imageId: number) {
    return axiosInstance.post(`${this.urlMovie()}/${id}/attach/gallery`, {id: imageId})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });

  }

  sortCategories(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  sortMovies(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlMovie()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteSeries(query: string, source: any) {
    return axiosInstance.get(`${this.urlMovie()}/series?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteSource(movieId: number, sourceID: number) {
    return axiosInstance.delete(`${this.urlMovie()}/${movieId}/sources/${sourceID}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewSource(id: number, sources: any) {
    return axiosInstance.post(`${this.urlMovie()}/${id}/sources`, sources)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        if (e.response.data.responseCode == 400) {
          showToaster('warning', 'Error', e.response.data.error.message, 400);
        } else {
          showToaster('danger', 'Error', e.response.data.error.message);
        }
        generateLog(log);
        showToaster('danger', 'Error', e.response.data.error.message);
      });
  }

  editExistingSource(id: number, source: any) {
    return axiosInstance.put(`${this.urlMovie()}/${id}/sources/${source.id}`, source)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCategoryFromMovie(channel: IVIDEO, n: any) {
    return axiosInstance.post(`${this.urlMovie()}/${channel.id}/detach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  attachMovieToCategory(category: IVIDEOCategories, ids: number[]) {
    return axiosInstance.post(`${this.urlCategory()}/${category.id}/attach`, ids)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  editVODMovie(tempMovie: IVIDEO) {
    return axiosInstance.put(`${this.urlMovie()}/${tempMovie.id}`, tempMovie)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.urlMovie()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.urlMovie()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewItem(newVOD: IVIDEO) {
    return axiosInstance.post(`${this.urlMovie()}`, newVOD)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCategoryToMovie(movie: IVIDEO, n: any) {
    return axiosInstance.post(`${this.urlMovie()}/${movie.id}/detach`, {name: n})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCategoryToMovie(movie: IVIDEO, n: any) {
    return axiosInstance.post(`${this.urlMovie()}/${movie.id}/attach`, {name: n})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  attachPackageToMovie(movie: IVIDEO, n: any) {
    return axiosInstance.post(`${this.urlMovie()}/${movie.id}/package`, {name: n})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  detachPackageToMovie(movie: IVIDEO, n: any) {
    return axiosInstance.post(`${this.urlMovie()}/${movie.id}/detachpackage`, {name: n})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  editVODCategory(cat: IVIDEOCategories) {
    return axiosInstance.put(`${this.urlCategory()}/${cat.id}`, cat)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  getSubItems(id: number, search: string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}/content?search=${search}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchData(index = 1, search: string | null, perpage: number | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (search) {
      return axiosInstance.get(`${this.urlMovie()}?search=${search}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'VIDEO',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.urlMovie()}?page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'VIDEO',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  getSelectedVODMovie(id: number) {
    return axiosInstance.get(`${this.urlMovie()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  getSpecificCategory(id: number) {
    return axiosInstance.get(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  getAllCategories(search: string | null = null) {
    if (cancel !== undefined) {
      cancel();
    }
    const searchString = (Boolean(search)) ? `search=${search}` : '';
    return axiosInstance.get(`${this.urlCategory()}?${searchString}`, {
      cancelToken: new CancelToken(function executor(c: any) {cancel = c; }),
    }).then((response) => response.data).catch((e) => {
      const log: any = {
        route: 'VIDEO',
        message: e,
      };
      generateLog(log);
    });
  }

  createNewCategory(cat: ICategories) {
    return axiosInstance.post(`${this.urlCategory()}`, {category: cat})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  createCategory(category: IVIDEOCategories, parentId: string) {
    const data = category;
    if (parentId !== '') {
      data.parentId = Number(parentId);
    }
    return axiosInstance.post(`${this.urlCategory()}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteCategory(id: number) {
    return axiosInstance.delete(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  import(data: any, tableName: string, id: any) {
    return axiosInstance.post(`import/${tableName}?type=module&module_id=${id}`, {data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

  export(tableName: string, id: any) {
    return axiosInstance.get(`export/${tableName}?type=module&module_id=${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'VIDEO',
          message: e,
        };
        generateLog(log);
      });
  }

}
